module.exports = __webpack_public_path__ + "static/img/arrow.614dbaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/arrow.png
// module id = sYvH
// module chunks = 0